module.exports = __webpack_public_path__ + "static/media/landing_video_compressed.c6d56765.mp4";